export function sequence(items, consumer) {
    const results = [];
    const runner = () => {
        const item = items.shift();
        if(typeof item !== 'undefined') {
            return consumer(typeof item === 'function' ? item() : item)
            .then(result => {
                results.push(result);
            })
            .then(runner);
        }

        return Promise.resolve(results);
    };

    return runner();
}

// Exécute `consumer` sur chaque item avec au plus `concurrency` promesses en parallèle.
// Les résultats conservent l'ordre initial des items (utile pour compter les succès).
// concurrency <= 1 équivaut à un traitement séquentiel.
export function pool(items, consumer, concurrency = 4) {
    const entries = [...items];
    const results = new Array(entries.length);
    const limit = Math.max(1, concurrency);
    let nextIndex = 0;

    const worker = () => {
        const currentIndex = nextIndex;
        nextIndex += 1;
        if(currentIndex >= entries.length) {
            return Promise.resolve();
        }
        const item = entries[currentIndex];
        return consumer(typeof item === 'function' ? item() : item, currentIndex)
        .then(result => {
            results[currentIndex] = result;
        })
        .then(worker);
    };

    const workers = [];
    for(let i = 0; i < Math.min(limit, entries.length); i++) {
        workers.push(worker());
    }

    return Promise.all(workers).then(() => results);
}

export function sleep(milliseconds) {
    const start = new Date().getTime();
    for(let i = 0; i < 1e7; i++) {
        if((new Date().getTime() - start) > milliseconds) {
            break;
        }
    }
}
